import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-asahi-banner',
  imports: [TranslatePipe],
  templateUrl: './asahi-banner.component.html',
  styleUrl: './asahi-banner.component.scss'
})
export class AsahiBannerComponent {
  scrollToForm() {
    const element = document.getElementById('leads-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

}
